import { companyQueryOptions } from '@/hooks/queries/company.queries';
import { useQuery } from '@tanstack/react-query';

export function useCompanyServices(companyId?: string) {
  const { data, isError, isFetching, isLoading, refetch } = useQuery(companyQueryOptions.services(companyId));

  return {
    isError,
    isFetching,
    isLoading,
    pagination: data?.pagination,
    refetch,
    services: data?.data ?? [],
  };
}
